/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FilesListAliases {
  MODAL_FILES = 'modal-files',
  TABLE_COLUMN_ACTIONS = 'table-column-actions',
  TABLE_COLUMN_FILENAME = 'table-column-filename',
  TABLE_FILES = 'table-files',
}
export { FilesListAliases };
